module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "star"
  }, _vm._l((_vm.countWaves), function(w) {
    return _c('div', {
      staticClass: "wave"
    }, _vm._l((_vm.countLines), function(l) {
      return _c('div', {
        staticClass: "line"
      }, [_c('div', {
        staticClass: "dot"
      }, [_vm._v(_vm._s(l.toString(2)))])])
    }))
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6b50a898"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RainbowComponent.vue
// module id = 127
// module chunks = 1